export const BAD_DEBT_REASONS = [
  "Customer uncontactable / absconded",
  "Refuses to pay",
  "Deceased",
  "Bankrupt / no ability to pay",
  "Business closed",
  "Fraud / fake details",
  "Other",
];

export const ADMIN_ROLES = ["director", "manager", "admin"];
